(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["firstroot-diwali-welcome"]) return;
  try {
    
  (() => {
    const init = () => {
      const overlay = document.getElementById('fr-diwali-welcome');
      if (!overlay || overlay.dataset.initialized) return;
      overlay.dataset.initialized = 'true';
      const art = overlay.querySelector('.fr-diwali__art-main');
      const effects = overlay.querySelector('.fr-diwali__effects');
      const compact = window.matchMedia('(max-width: 600px)').matches;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      {
        const points = [[12,19,19],[28,8,17],[48,11,16],[68,9,22],[84,21,18],[95,37,21],[93,65,18],[80,85,23],[62,92,17],[42,88,21],[23,86,19],[7,70,23],[2,43,18],[18,56,15],[55,3,19],[99,52,18],[54,97,20],[0,28,17]];
        points.slice(0, compact ? 12 : 14).forEach(([x,y,size], index) => {
          const star = document.createElement('span');
          star.className = 'fr-diwali__spark';
          star.style.setProperty('--x', x + '%');
          star.style.setProperty('--y', y + '%');
          star.style.setProperty('--size', size + 'px');
          star.style.setProperty('--delay', ((index * .13) % .55) + 's');
          effects.appendChild(star);
        });
        const moteCount = reducedMotion ? 0 : compact ? 6 : 8;
        for (let i = 0; i < moteCount; i++) {
          const angle = i * Math.PI * 2 / moteCount;
          const mote = document.createElement('span');
          mote.className = 'fr-diwali__mote';
          mote.style.setProperty('--x', (50 + Math.cos(angle) * 46) + '%');
          mote.style.setProperty('--y', (50 + Math.sin(angle) * 40) + '%');
          mote.style.setProperty('--delay', ((i % 6) * .08) + 's');
          mote.style.setProperty('--dx', ((i % 2 ? 1 : -1) * 14) + 'px');
          effects.appendChild(mote);
        }
        (reducedMotion ? [] : [[5,36,.2],[92,61,.7]]).forEach(([x,y,delay]) => {
          const burst = document.createElement('span');
          burst.className = 'fr-diwali__burst';
          burst.style.setProperty('--x', x + '%');
          burst.style.setProperty('--y', y + '%');
          const rayCount = compact ? 4 : 6;
          for (let i = 0; i < rayCount; i++) {
            const angle = i * Math.PI * 2 / rayCount;
            const ray = document.createElement('span');
            ray.className = 'fr-diwali__ray';
            ray.style.setProperty('--dx', (Math.cos(angle) * 40) + 'px');
            ray.style.setProperty('--dy', (Math.sin(angle) * 40) + 'px');
            ray.style.setProperty('--delay', delay + 's');
            burst.appendChild(ray);
          }
          effects.appendChild(burst);
        });
      }
      let openingTimer;
      let cleanupTimer;
      let scrollTimer;
      const onScroll = () => {
        if (overlay.hidden) return;
        if (!overlay.classList.contains('fr-diwali--scrolling')) overlay.classList.add('fr-diwali--scrolling');
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(() => overlay.classList.remove('fr-diwali--scrolling'), 160);
      };
      const finish = () => {
        overlay.hidden = true;
        overlay.classList.remove('fr-diwali--visible', 'fr-diwali--scrolling');
        window.clearTimeout(cleanupTimer);
        window.clearTimeout(scrollTimer);
        window.removeEventListener('scroll', onScroll, true);
        window.removeEventListener('wheel', onScroll);
        window.removeEventListener('touchmove', onScroll);
      };
      const show = () => {
        if (!overlay.isConnected) return;
        if (document.hidden) { document.addEventListener('visibilitychange', retry); return; }
        overlay.hidden = false;
        overlay.classList.add('fr-diwali--visible');
        window.addEventListener('scroll', onScroll, { passive: true, capture: true });
        window.addEventListener('wheel', onScroll, { passive: true });
        window.addEventListener('touchmove', onScroll, { passive: true });
        cleanupTimer = window.setTimeout(finish, 3000);
      };
      const retry = () => { if (!document.hidden) { document.removeEventListener('visibilitychange', retry); show(); } };
      const schedule = async () => {
        if (art.naturalWidth === 0) return;
        try { await art.decode(); } catch {}
        if (overlay.isConnected) openingTimer = window.setTimeout(show, 180);
      };
      if (art.complete) schedule();
      else art.addEventListener('load', schedule, { once: true });
      art.addEventListener('error', finish, { once: true });
      overlay.addEventListener('animationend', event => { if (event.target === overlay && event.animationName === 'fr-diwali-fade') finish(); });
      document.addEventListener('shopify:section:unload', event => {
        if (!event.target.contains(overlay)) return;
        window.clearTimeout(openingTimer);
        art.removeEventListener('load', schedule);
        document.removeEventListener('visibilitychange', retry);
        finish();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fr-hero"] && !Shopify.designMode) return;
  try {
    
const firstRootHeroVideos = new Map();
function firstRootHeroUpdate(video, state) {
  if (!video.isConnected) {
    video.pause();
    firstRootHeroObserver?.unobserve(video);
    firstRootHeroVideos.delete(video);
    return;
  }
  if (state.button) state.button.hidden = false;
  if (!state.visible || document.hidden || state.userPaused) {
    video.pause();
    return;
  }
  const source = video.querySelector('source[data-src]');
  if (source && !source.hasAttribute('src')) {
    source.src = window.matchMedia('(max-width: 749px)').matches && source.dataset.mobileSrc ? source.dataset.mobileSrc : source.dataset.src;
    video.load();
  }
  video.play().catch(() => {
    state.failed = true;
    if (state.button) state.button.hidden = false;
  });
}
const firstRootHeroObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
  entries.forEach(entry => {
    const state = firstRootHeroVideos.get(entry.target);
    if (!state) return;
    state.visible = entry.isIntersecting;
    firstRootHeroUpdate(entry.target, state);
  });
}, { threshold: 0.1 }) : null;
function firstRootHeroRefresh() {
  firstRootHeroVideos.forEach((state, video) => firstRootHeroUpdate(video, state));
}
function firstRootHeroInitialize() {
  document.querySelectorAll('.fr-hero__video').forEach(video => {
    if (firstRootHeroVideos.has(video)) return;
    const button = video.parentElement.querySelector('.fr-hero__video-control');
    const state = { visible: !firstRootHeroObserver, userPaused: false, manual: false, failed: false, button };
    firstRootHeroVideos.set(video, state);
    if (button) {
      const syncButton = () => {
        const paused = video.paused || video.ended;
        button.dataset.paused = String(paused);
        button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
      };
      video.addEventListener('play', syncButton);
      video.addEventListener('pause', syncButton);
      video.addEventListener('ended', syncButton);
      syncButton();
      button.addEventListener('click', () => {
        state.manual = true;
        state.visible = true;
        state.userPaused = !video.paused;
        firstRootHeroUpdate(video, state);
      });
    }
    firstRootHeroObserver?.observe(video);
    firstRootHeroUpdate(video, state);
  });
}
firstRootHeroInitialize();
document.addEventListener('shopify:section:load', firstRootHeroInitialize);
document.addEventListener('shopify:section:unload', firstRootHeroRefresh);
document.addEventListener('visibilitychange', firstRootHeroRefresh);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
(() => {
  const css = `
    :host {display:block;width:100%;font-family:Arial,Helvetica,sans-serif}
    :host .sr-delivery-widget {width:100%!important;max-width:none!important;max-height:none!important;margin:0!important;background:transparent!important;box-shadow:none!important}
    :host .sr-delivery-container {box-sizing:border-box!important;width:100%!important;max-width:none!important;margin:0!important;padding:20px!important;border:1px solid #dce5dc!important;border-radius:14px!important;background:#f3f7f1!important;font-family:Arial,Helvetica,sans-serif!important;box-shadow:none!important}
    :host .sr-delivery-widget .sr-title {font:600 18px/1.4 Arial,Helvetica,sans-serif!important;color:#173e2b!important;margin:0 0 14px!important;text-align:left!important;letter-spacing:0!important}
    :host .sr-input-group {display:grid!important;grid-template-columns:minmax(0,1fr) auto!important;align-items:center!important;gap:12px!important;height:auto!important;min-height:48px!important;padding:0!important;border:0!important;min-width:0;position:relative!important}
    :host .sr-input-group[style*="display: none"],:host .sr-input-group[style*="display:none"] {display:none!important}
    :host .sr-input-group:has(.sr-check-btn[style*="display: none"]) {grid-template-columns:minmax(0,1fr)!important;gap:0!important}
    :host .sr-pincode-input {box-sizing:border-box!important;flex:1!important;min-width:0!important;width:100%!important;height:48px!important;border:1px solid #bdccbd!important;border-radius:8px!important;background:white!important;padding:12px!important;font:16px/1.4 Arial,Helvetica,sans-serif!important;color:#173e2b!important}
    :host .sr-pincode-input::placeholder {font-size:14px!important;color:#617363!important;opacity:1!important}
    :host .sr-input-group .sr-check-btn {box-sizing:border-box!important;flex:0 0 auto!important;position:static!important;transform:none!important;width:auto!important;height:48px!important;min-height:48px!important;padding:12px 20px!important;border:0!important;border-radius:8px!important;background:#173e2b!important;color:white!important;font:600 15px/1.4 Arial,Helvetica,sans-serif!important;cursor:pointer}
    :host .sr-input-group .sr-check-btn:hover {background:#28553d!important}
    :host .sr-result,:host .sr-loader-text {font:14px/1.6 Arial,Helvetica,sans-serif!important;white-space:normal!important;flex-wrap:wrap!important}
    :host .sr-loader-text {box-sizing:border-box!important;position:absolute!important;inset:0!important;min-height:48px!important;padding:12px 16px!important;border:1px solid #bdccbd!important;border-radius:8px!important;background:white!important;color:#173e2b!important;z-index:2!important}
    :host .sr-loader {right:16px!important;top:50%!important;transform:translateY(-50%)!important;z-index:3!important}
    :host .sr-result:not(:empty) {margin-top:14px!important}
    :host .sr-result .pincode,:host .sr-result .delivery-date {font:600 20px/1.5 Arial,Helvetica,sans-serif!important;color:#173e2b!important;min-height:44px!important;padding:8px!important;border-bottom:0!important;background:white!important;border-radius:8px!important}
    :host .sr-result .pincode img,:host .sr-result .delivery-date img {width:28px!important;height:28px!important;flex:0 0 28px!important}
    :host .sr-footer-edd .sr-change-pincode {font:600 14px/1.5 Arial,Helvetica,sans-serif!important;color:#173e2b!important;padding:8px 0!important}
    :host .sr-pincode-input:focus-visible,:host .sr-check-btn:focus-visible {outline:2px solid #50774d!important;outline-offset:3px!important}
    @media(max-width:480px){:host .sr-delivery-container{padding:16px!important}:host .sr-input-group .sr-check-btn{padding:12px 16px!important}}
  `;
  const wiredRoots = new WeakSet();
  const syncDeliveryFocus = () => {
    const root = document.querySelector('.product-information #delivery-widget')?.shadowRoot;
    const active = root?.activeElement?.matches('.sr-pincode-input') || false;
    document.documentElement.classList.toggle('fr-delivery-input-active',active);
  };
  const apply = () => {

    const host = document.querySelector('.product-information #delivery-widget');
    const root = host && host.shadowRoot;
    if (!root) return;
    if (!wiredRoots.has(root)) {
      wiredRoots.add(root);
      root.addEventListener('focusin',syncDeliveryFocus);
      root.addEventListener('focusout',() => setTimeout(syncDeliveryFocus,0));
      syncDeliveryFocus();
    }
    if (root.querySelector('#firstroot-delivery-polish')) return;
    const style = document.createElement('style');
    style.id = 'firstroot-delivery-polish';
    style.textContent = css;
    root.appendChild(style);
    const input = root.querySelector('.sr-pincode-input');
    if (input && !input.getAttribute('aria-label')) input.setAttribute('aria-label',input.getAttribute('placeholder'));
  };
  apply();
  let attempts = 0;
  const timer = setInterval(() => {
    apply();
    if (++attempts >= 120) clearInterval(timer);
  },500);
  document.addEventListener('shopify:section:load',apply);
  document.addEventListener('shopify:section:unload',() => setTimeout(syncDeliveryFocus,0));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial"] && !Shopify.designMode) return;
  try {
    
        document.addEventListener('DOMContentLoaded', function () {
          document.querySelectorAll('.testimonial-item').forEach((item) => {
            const video = item.querySelector('video');
            const button = item.querySelector('.play-pause-button');
            const playState = button?.querySelector('.play-state');
            const pauseState = button?.querySelector('.pause-state');
            const iconWrapper = button?.querySelector('.icon-wrapper');

            if (!video || !button) return;
            iconWrapper?.setAttribute('title', 'Pause');

            button.addEventListener('click', () => {
              if (video.paused) {
                video.play();
                iconWrapper?.setAttribute('title', 'Pause');
                playState.removeAttribute('hidden');
                pauseState.setAttribute('hidden', '');
              } else {
                video.pause();
                iconWrapper?.setAttribute('title', 'Play');
                pauseState.removeAttribute('hidden');
                playState.setAttribute('hidden', '');
              }
            });
          });

          // Only original (non-duplicate) videos ever load/play.
          // Duplicate marquee clones stay as static poster images — no video load, no decode cost.
          const videoObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
              const video = entry.target;
              if (entry.isIntersecting) {
                video.muted = true;
                video.playsInline = true;

                const tryPlay = () => {
                  const p = video.play();
                  if (p && typeof p.catch === 'function') {
                    p.catch(() => {
                      setTimeout(() => video.play().catch(() => {}), 150);
                    });
                  }
                };

                if (video.readyState >= 2) {
                  tryPlay();
                } else {
                  video.addEventListener('loadeddata', tryPlay, { once: true });
                  video.addEventListener('canplay', tryPlay, { once: true });
                  if (video.readyState === 0) {
                    video.load();
                  }
                }
              } else {
                video.pause();
              }
            });
          }, { threshold: 0.1 });

          document.querySelectorAll('video.marquee-video').forEach(video => {
            videoObserver.observe(video);
          });
        });
      
  } catch(e) { console.error(e); }
})();
})();
